import { render, staticRenderFns } from "./TeacherTabs.vue?vue&type=template&id=3d0bcbf0&"
import script from "./TeacherTabs.vue?vue&type=script&lang=js&"
export * from "./TeacherTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports